import React from 'react';
import { motion } from 'framer-motion';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="bg-stage water-glow tech-grid py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-47" data-mp="ounbyzutcaqa">
      <div className="mx-auto max-w-4xl px-4" data-id="element-48" data-mp="12uesb78sy37g">
        <div className="text-center" data-id="element-49" data-mp="xu0oy2i5bhfr">
          <h2 id="closing-title" className="text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-50" data-mp="xsz6ve2ppuoj">
            Next Monday you can keep improvising…
          </h2>
          <p className="mt-4 font-display text-2xl font-extrabold text-silver sm:text-3xl" data-id="element-51" data-mp="17qvkqdn1b3qc">
            Or you can enter your classroom fully prepared starting today.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-52" data-mp="1hisvxke1lvp2">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="panel-dark flex items-center gap-3 rounded-lg border-l-4 border-silver px-4 py-3 text-sm font-semibold text-silverBright" data-id="element-53" data-mp="1viaq6fa3y15t" data-mpi={index}>
              <span className="font-display text-silver" aria-hidden="true" data-id="element-54" data-mp="2ccwe27feqxro">
                ▸
              </span>
              {line}
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-55" data-mp="2laybye3uhaaq">
          <p className="leading-relaxed text-silverDark" data-id="element-56" data-mp="2q99jgi6o38ps">
            This collection won't make you a better educator. You're already an excellent educator.
          </p>
          <p className="mt-3 text-lg font-bold text-white" data-id="element-57" data-mp="2zzuq8swhvjjs">
            What this collection does is give you the time and tools so that excellence shows in every single class.
          </p>
        </div>
      </div>
    </section>;
}